import { render, staticRenderFns } from "./CtrlDaibunrui.vue?vue&type=template&id=0a3bbaae&"
import script from "./CtrlDaibunrui.vue?vue&type=script&lang=ts&"
export * from "./CtrlDaibunrui.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports